<template>
    <div>
      <router-view :key="$route.fullPath"></router-view>
    </div>

</template>

<script lang='ts'>

import { defineComponent } from 'vue'
import applicationUserManager from '../../core/applicationusermanager'

export default defineComponent({
  name: 'reportsView',
  async beforeMount () {
    const user = await applicationUserManager.getUserInfo()
    if (!user) {
      this.$router.push('/login')
    }
  }
})

</script>
